<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb
        :crumbs="[
          $t('menu.reports'),
          $t('reports.supplierOver') + $t('text.detail'),
        ]"
      >
      </breadcrumb>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button type="default" size="mini" @click="download">
              {{ $t("action.download") }}
            </el-button>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        :loading="loading"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red">
              ({{ $t("order.hurrySimple") }})
            </small>
            {{ row.serialNo }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="workflowState"
          :title="$t('text.workflowState')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <state-label :state="row.workflowState">
              {{ $t("purchaseStates." + row.workflowState) }}
            </state-label>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="supplierName"
          :title="$t('menu.suppliers')"
          min-width="80"
        />
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <small
              v-if="
                row.customerProductNo != null && row.customerProductNo != ''
              "
            >
              ({{ row.customerProductNo }})
            </small>
            <div class="font10">
              {{ row.categoryName }}
              <span v-if="row.productBrand != null">/</span>
              {{ row.productBrand }}
            </div>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="60"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="price"
          :title="$t('purchase.price')"
          min-width="70"
        >
          <template v-slot="{ row }">
            {{ row.price | currency }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="giveAt"
          :title="$t('purchase.giveAt')"
          min-width="110"
        />

        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.handOverAt }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="finishAt"
          :title="$t('purchase.finishAt')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.finishAt }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="receiveQuantity"
          :title="'已收数量'"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.receiveQuantity }}{{ row.unit }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="unReceiveQuantity"
          :title="'未收数量'"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.quantity - row.receiveQuantity }}{{ row.unit }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="ownerName"
          :title="$t('order.handler')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.handlerName }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="handleDept"
          :title="$t('order.handleDepart')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.handleDept }}
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>
<script>
import { page, table } from "@/utils/mixins.js";
import DateRange from "@/components/DateRange";
import Purchase from "@/api/purchase";

export default {
  mixins: [page, table.pager, table.search],
  components: { DateRange },
  data() {
    return {
      //
      records: [],
      loading: false,
    };
  },

  created() {
    const self = this;
    self.loadData();
  },
  methods: {
    //
    loadData() {
      const self = this;
      self.loading = true;
      Purchase.supplierOverReportDetail(self.$route.query).then(function (res) {
        self.loading = false;
        if (res.status === 200) {
          self.records = res.data;
        } else {
          self.sysError();
        }
      });
    },
    //
    download() {
      const self = this;
      if (self.records.length == 0) {
        this.$message({
          message: self.$t("text.noData"),
          type: "warning",
        });
        return;
      }
      Purchase.supplierOverReportDetailExportExcel(self.$route.query).then(
        function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.downloadPrompt"),
              type: "success",
            });
            self.checkedRows = [];
            self.$eventHub.$emit("emitDownLoad");
          } else {
            self.$message.error(self.$t("prompt.downloadErr"));
          }
        }
      );
    },
  },
};
</script>
<style >
.el-form-item__content {
  height: auto !important;
}
</style>